import { Directive, DOCUMENT, inject, OnInit, DestroyRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter } from 'rxjs/operators';
import { ScrollerService } from './scroller.service';

@Directive({
  selector: '[appScroller]'
})
export class ScrollerDirective implements OnInit {
  #destroyRef = inject(DestroyRef);
  private router = inject(Router);
  private scrollerService = inject(ScrollerService);
  private documentRef = inject(DOCUMENT);

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        filter((event: NavigationEnd) =>
          this.scrollerService.isRouteRegistered(event.url)
        ),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(() => {
        // Appears as if NavigateEnd event is sometimes fired too soon. So that scrolling to top doesn't
        // work e.g. on object edit flow. Setting scrollPositionRestoration alone does not do the trick either.
        setTimeout(() => {
          this.scrollToTop();
        });
      });
  }

  private scrollToTop() {
    this.documentRef.body.scrollTo(0, 0);
  }
}
